<template>
  <WithdrawDataTable></WithdrawDataTable>
</template>

<script>

import WithdrawDataTable from './WithdrawDataTable.vue';

export default {
  components: { WithdrawDataTable },
};
</script>